import PropTypes from 'prop-types';
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';

import { SiteNavFullWidthDropdownContent } from './SiteNavFullWidthDropdownContent';
import { SiteNavPartialWidthDropdownContent } from './SiteNavPartialWidthDropdownContent';

const SiteNavDropdownContent = ({
    items: moduleItems,
    trackingLabelPrefix,
    showFullWidthNav,
    navigationModule,
    onImageModuleFirstImpression,
    onImageModuleClick,
    isVisible,
}) => {
    const navProps = { moduleItems, trackingLabelPrefix };

    if (showFullWidthNav) {
        // Full-width nav
        return (
            <SiteNavFullWidthDropdownContent
                {...navProps}
                navigationModule={navigationModule}
                onImageModuleFirstImpression={onImageModuleFirstImpression}
                onImageModuleClick={onImageModuleClick}
                isVisible={isVisible}
            />
        );
    } else {
        // Original partial width nav
        return <SiteNavPartialWidthDropdownContent {...navProps} />;
    }
};

SiteNavDropdownContent.propTypes = {
    items: PropTypes.array,
    trackingLabelPrefix: PropTypes.string,
    showFullWidthNav: PropTypes.bool,
    navigationModule: PropTypes.object,
    onImageModuleFirstImpression: PropTypes.func,
    onImageModuleClick: PropTypes.func,
    isVisible: PropTypes.bool,
};

export default createFragmentContainer(SiteNavDropdownContent, {
    navigationModule: graphql`
        fragment SiteNavDropdownContent_navigationModule on NavigationModule {
            ...SiteNavFullWidthDropdownContent_navigationModule
        }
    `,
});
